import React from "react";
import Form from "./form";
import List from "./list";
import { useParams, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Spin from "../_lib/spin/spin";

const Invoice = () => {
    const width = window.innerWidth;
    const { arg1 } = useParams();

    const { item, message } = useSelector(state => state.Invoice);

    if (item === null && message)
    return <h3 className="invoice__alert">{message}</h3>
    
    return (
        <div className="invoice">
            <div className="Container">
                {width > 992 ? (
                    <>
                        <List />
                        <Form />
                    </>
                ) : arg1 === "list" ? (
                    <List />
                ) : (
                    <Form />
                )}
            </div>
        </div>
    );
};

export default Invoice;
